<template>
    <div>
        <UiHeroTop 
        :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />  
        

    </div>
    <UiImageFlip 
        v-for="(article, index) in blogStore.filterArticlesByTag(blog, 'Additional Info')" 
        :key="index" 
        :article="article"
        :class="['smallscreen-margin', {'mt-16': index !== 0, 'mt-0': index === 0}]"      />


    <div class="mt-32 mb-16 smallscreen-margin">
      <UiHeroBottom 
      :article="blogStore.filterArticlesByTag(blog, 'Herobottom')[0]" />  
    </div>
</template>
  
<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});


</script>
  
<style>

@media (max-width: 480px) { /* Extra small screens */
  .smallscreen-margin {
    margin-top: 32px;
    margin-bottom: 32px;
  }
}


</style>
  